import React, { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FaDiscord, FaInstagram } from 'react-icons/fa';
import { motion } from 'framer-motion';
import RedirectModal from './RedirectModal';
import '../styles/Footer.css';

const Footer = () => {
    const [showModal, setShowModal] = useState(false);
    const [modalConfig, setModalConfig] = useState({
        url: '',
        title: '',
        message: ''
    });

    const handleSocialRedirect = (url, type) => {
        setModalConfig({
            url: url,
            title: <span>{type.toUpperCase()} <span className="text-neon-cyan">REDIRECT</span></span>,
            message: `You are taking a flight to our official ${type} page:`
        });
        setShowModal(true);
    };

    const confirmRedirect = () => {
        window.open(modalConfig.url, '_blank');
        setShowModal(false);
    };

    return (
        <footer className="py-5 mt-auto" style={{
            background: '#050505',
            borderTop: '1px solid rgba(0, 243, 255, 0.1)',
            position: 'relative'
        }}>
            <div style={{
                position: 'absolute',
                top: 0, left: 0, width: '100%', height: '1px',
                background: 'linear-gradient(90deg, transparent, var(--neon-cyan), transparent)',
                opacity: 0.5
            }} />

            <Container fluid className="px-5">
                <Row className="gy-4 align-items-start justify-content-between">
                    <Col md={4} className="text-center text-md-start">
                        <h5 className="fw-bold mb-3" style={{ fontFamily: 'Orbitron, sans-serif', color: '#fff', letterSpacing: '1px' }}>
                            THALAINAGARAM <span className="text-neon-cyan">RP</span>
                        </h5>
                        <p className="text-secondary mb-0 small" style={{ maxWidth: '400px' }}>
                            Dive into high quality Tamil roleplay and build your empire on the realistic streets of Thalainagaram. Join the experience.
                        </p>
                    </Col>
                    <Col md={4} className="text-center text-md-center">
                        <h5 className="text-white fw-bold mb-3" style={{ fontFamily: 'Orbitron, sans-serif', letterSpacing: '1px' }}>
                            HOSTING <span className="text-neon-cyan">CREDITS</span>
                        </h5>
                        <div className="text-secondary small">
                            <p className="text-white fw-semibold mb-1">
                                CYBERJET PTE. LTD.
                            </p>
                            <p className="text-secondary mb-1">
                                Singapore
                            </p>
                            <a
                                href="https://www.skylineconnect.io/en"
                                onClick={(e) => {
                                    e.preventDefault();
                                    handleSocialRedirect('https://www.skylineconnect.io/en', 'Skyline Connect');
                                }}
                                className="text-neon-cyan text-decoration-none hover-text-accent"
                                style={{ transition: 'all 0.3s ease', cursor: 'pointer' }}
                            >
                                https://www.skylineconnect.io/en
                            </a>
                        </div>
                    </Col>
                    <Col md={4} className="text-center text-md-end">
                        <h5 className="text-white fw-bold mb-3" style={{ fontFamily: 'Orbitron, sans-serif', letterSpacing: '1px' }}>CONNECT</h5>
                        <div className="d-flex gap-4 justify-content-center justify-content-md-end">
                            <motion.div
                                whileHover={{ scale: 1.2, color: '#E1306C', textShadow: '0 0 10px #E1306C' }}
                                onClick={() => handleSocialRedirect('https://www.instagram.com/thalai_nagaram_rp/?igsh=b2tzNmNpdWljZ2dl#', 'Instagram')}
                                className="text-white fs-4 transition-all"
                                style={{ transition: 'all 0.3s ease', cursor: 'pointer' }}
                            >
                                <FaInstagram />
                            </motion.div>
                            <motion.div
                                whileHover={{ scale: 1.2, color: '#5865F2', textShadow: '0 0 10px #5865F2' }}
                                onClick={() => handleSocialRedirect('https://discord.gg/xpmRWVFZYR', 'Discord')}
                                className="text-white fs-4 transition-all"
                                style={{ transition: 'all 0.3s ease', cursor: 'pointer' }}
                            >
                                <FaDiscord />
                            </motion.div>
                        </div>
                    </Col>
                </Row>
                <hr className="border-secondary my-4 opacity-25" />
                <p className="text-center text-secondary mb-0 small text-uppercase tracking-widest">
                    &copy; {new Date().getFullYear()} Thalainagaram RP. All rights reserved.
                </p>
            </Container>

            <RedirectModal
                show={showModal}
                handleClose={() => setShowModal(false)}
                handleConfirm={confirmRedirect}
                title={modalConfig.title}
                messageLabel={modalConfig.message}
                targetUrl={modalConfig.url}
                variant="application"
            />
        </footer>
    );
};

export default Footer;
